module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('i', [_vm._v("Thanks to all those who helped me bring this story to life. It’s impossible to say enough about Linda, my brilliant muse, consultant, and friend—the spirit of Lianelle. And then, of course, Susan, Laurey, Glenn, Brian, Catherine, and Curt, who prod me to be better, and Brenda, who prods me to be. Thanks to Markus, the Fighter Guy, for his invaluable consultations. But most especially this is for Pete, the Exceptional Spouse, whose patience and care keep life beautiful and together. I love you all.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e12992","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedication.vue
// module id = 69
// module chunks = 0